<template>
    <div class="wrapper">
        <div class="image-wrap">
            <div class="image" :style="`background-image: url(${img})`"></div>
            <div class="overlay" :class="{'inverse' : inverse}" v-if="img != null"></div>
        </div>
        <div
            class="navigation-card"
            :class="{
        'inverse' : inverse,
        'is-image' : (img != null),
        'interactable' : (url != null),
        }"
            @click="navigate(url)"
        >
            <div class="card-header" v-if="hasSlot($slots.header)">
                <slot name="header"></slot>
            </div>

            <div class="card-content" v-if="hasSlot($slots.content)">
                <slot name="content"></slot>
            </div>

            <div class="card-quote" v-if="hasSlot($slots.quote)">
                <slot name="quote"></slot>
            </div>

            <div class="card-contact" v-if="hasSlot($slots.contact)">
                <slot name="contact"></slot>
            </div>

            <div class="arrow" :class="{'inverse' : inverse}" v-if="url != null"></div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        inverse: Boolean,
        img: String,
        url: String
    },
    methods: {
        hasSlot(slot) {
            return !!slot;
        },

        navigate(url) {
            if (url == null) {
                return;
            }

            this.$router.push(url);
        }
    }
};
</script>

<style scoped lang="scss">
.wrapper {
    width: 100%;
    position: relative;

    .image-wrap {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: block;

        z-index: -1;

        .image {
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
            position: absolute;
            top: 0;
            left: 0;

            z-index: -1;
        }

        .overlay {
            z-index: 1;
            width: 100%;
            height: 100%;
            background-color: rgba(255, 255, 255, 0.25);

            &.inverse {
                background-color: rgba(0, 0, 0, 0.5);
            }
        }
    }
}

.navigation-card {
    @include cover-center;
    padding: 40px;

    display: flex;
    flex-direction: column;
    justify-content: center;

    white-space: pre-line;

    height: 100%;

    position: relative;
    transition: transform 0.2s ease-in-out;

    &.interactable:hover {
        cursor: pointer;
        transform: scale(1.015);
        z-index: 100;

        .arrow {
            transform: rotate(-90deg);
        }
    }

    background-color: #f5f4eb;

    &.inverse {
        background-color: black;
        color: white;
        z-index: 2;
    }

    .card-header {
        font-weight: bold;
        text-transform: uppercase;

        max-width: 40ch;

        margin-bottom: 30px;

        font-size: 28px;
    }

    .card-content {
        font-size: 16px;

        font-weight: lighter;

        max-width: 60ch;
        line-height: 30px;

        margin-bottom: 35px;
    }

    .card-quote {
        font-size: 18px;
        text-transform: uppercase;

        // display: flex;
        // justify-content: space-between;
    }

    .card-contact {
        display: flex;
        flex-direction: column;

        a {
            text-decoration: none;
            font-weight: bold;
            color: inherit;
        }
    }

    .arrow {
        height: 20px;
        width: 20px;

        background-image: url($arrow_down_black);
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;

        position: absolute;

        transition: transform 0.2s ease-in-out;

        right: 20px;
        bottom: 20px;

        &.inverse {
            background-image: url($arrow_down_white);
        }
    }

    &.is-image {
        background-color: transparent;
    }
}
</style>
